import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSquareBar = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "100%",
	height: "100%",
	viewBox: "0 0 128 128",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	xmlSpace: "preserve",
	"xmlns:serif": "http://www.serif.com/",
	style: {
		fillRule: "evenodd",
		clipRule: "evenodd",
		strokeLinecap: "round",
		strokeMiterlimit: 1.5
	},
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		transform: "matrix(1.04052,0,0,0.857459,-8.61607,19)",
		children: /* @__PURE__ */ _jsx("rect", {
			x: 26.541,
			y: 0,
			width: 86.495,
			height: 104.961,
			style: {
				fill: "rgb(41,41,41)",
				stroke: "rgb(41,41,41)",
				strokeWidth: "18.88px"
			}
		})
	})
});
export default SvgSquareBar;
